import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, NavLink, useLocation } from "react-router-dom";
import { IoLocation } from "react-icons/io5";
import { FiPhoneCall } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import { SiGmail } from "react-icons/si";

const Offcanvas = ({ menuOpen, closeMenu }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();

  const toggleMenu = (key) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const aboutActive = [
    "/about",
    "/team",
    "/chairman-msg",
    "/md-msg",
    "/directors",
    "/administrative",
  ].includes(location.pathname);

  const messageActive = ["/chairman-msg", "/md-msg"].includes(
    location.pathname,
  );

  const netActive = [
    "/fishing-net",
    "/agri_net",
    "/garden_net",
    "/build_net",
  ].includes(location.pathname);

  const ropeActive = ["/pp_rope", "/hdpe_rope"].includes(location.pathname);

  const mediaActive = ["/news", "/gallery", "/video"].includes(
    location.pathname,
  );

  const policyActive = ["/bepza_act", "/labor_law"].includes(location.pathname);

  useEffect(() => {
    if (messageActive) {
      setOpenMenus((prev) => ({
        ...prev,
        aboutMessages: true,
      }));
    }
  }, [messageActive]);

  return (
    <Wrapper>
      <div className="fix">
        <div
          className={`offcanvas-area ${menuOpen ? "info-open" : ""}`}
          data-lenis-prevent
        >
          <div className="offcanvas-wrapper">
            <div className="offcanvas-content">
              <div className="offcanvas-top d-flex justify-content-between align-items-center mb-20">
                <div className="offcanvas-logo">
                  <Link className="logo-black" to="index">
                    {/* <img src="/assets/images/logo/logo-orange.png" alt="logo"  /> */}
                    <img
                      src="/assets/images/logo/eque international.png"
                      alt="logo"
                      style={{ width: "180px", height: "64px" }}
                    />
                  </Link>
                </div>
                <div className="offcanvas-close" onClick={closeMenu}>
                  <button className="offcanvas-close-icon animation--flip">
                    <span className="offcanvas-m-lines">
                      <span className="offcanvas-m-line line--1"></span>
                      <span className="offcanvas-m-line line--2"></span>
                      <span className="offcanvas-m-line line--3"></span>
                    </span>
                  </button>
                </div>
              </div>

              <div className="mobile-menu">
                <div className="rs-offcanvas-menu mb-25">
                  <div className="mobile-menu mean-container">
                    <div className="mean-bar">
                      <Link
                        to="#nav"
                        className="meanmenu-reveal"
                        style={{
                          right: "0px",
                          left: "auto",
                          display: "inline",
                        }}
                      >
                        <span>
                          <span>
                            <span></span>
                          </span>
                        </span>
                      </Link>
                      <nav className="mean-nav">
                        <ul
                          className="multipage-menu"
                          style={{ display: "none" }}
                        >
                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Home
                            </NavLink>
                          </li>

                          <li
                            className={`menu-item-has-children ${
                              openMenus.about || aboutActive
                                ? "dropdown-opened"
                                : ""
                            }`}
                          >
                            <Link
                              to="#"
                              className={aboutActive ? "active" : ""}
                            >
                              About
                            </Link>

                            <Link
                              to="#"
                              className="mean-expand"
                              onClick={() => toggleMenu("about")}
                            >
                              <i
                                className={
                                  openMenus.about
                                    ? "fa-solid fa-xmark"
                                    : "fa-regular fa-plus"
                                }
                              ></i>
                            </Link>

                            <ul
                              className="submenu last-children"
                              style={{
                                display: openMenus.about ? "block" : "none",
                              }}
                            >
                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/about"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  About Eque International
                                </NavLink>
                              </li>

                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/team"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  Our Management Team
                                </NavLink>
                              </li>
                              <li
                                className={`has-arrow ${
                                  openMenus.aboutMessages
                                    ? "dropdown-opened"
                                    : ""
                                } ${messageActive ? "active" : ""}`}
                              >
                                <Link
                                  to="#"
                                  className={messageActive ? "active" : ""}
                                  onClick={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  Massages
                                </Link>

                                <Link
                                  to="#"
                                  className="mean-expand"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    setOpenMenus((prev) => ({
                                      ...prev,
                                      aboutMessages: !prev.aboutMessages,
                                    }));
                                  }}
                                >
                                  <i
                                    className={
                                      openMenus.aboutMessages
                                        ? "fa-solid fa-xmark"
                                        : "fa-regular fa-plus"
                                    }
                                  ></i>
                                </Link>

                                <ul
                                  className="submenu"
                                  style={{
                                    display: openMenus.aboutMessages
                                      ? "block"
                                      : "none",
                                  }}
                                >
                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/chairman-msg"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      Massages From Chairman
                                    </NavLink>
                                  </li>

                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/md-msg"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      Massages From MD
                                    </NavLink>
                                  </li>
                                </ul>
                              </li>

                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/directors"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  Board Of Directors
                                </NavLink>
                              </li>

                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/administrative"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  Administrative Officer
                                </NavLink>
                              </li>
                            </ul>
                          </li>
                          <li
                            className={`has-arrow ${
                              openMenus.nets || netActive
                                ? "dropdown-opened"
                                : ""
                            } ${netActive ? "active" : ""}`}
                          >
                            <Link to="#" className={netActive ? "active" : ""}>
                              Net & Roop
                            </Link>

                            <Link
                              to="#"
                              className="mean-expand"
                              onClick={() => toggleMenu("netRoop")}
                            >
                              <i
                                className={
                                  openMenus.netRoop
                                    ? "fa-solid fa-xmark"
                                    : "fa-regular fa-plus"
                                }
                              ></i>
                            </Link>

                            <ul
                              className="submenu last-children"
                              style={{
                                display: openMenus.netRoop ? "block" : "none",
                              }}
                            >
                              <li
                                className={`has-arrow ${
                                  openMenus.nets ? "dropdown-opened" : ""
                                }`}
                              >
                                <Link
                                  to="#"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  Net's
                                </Link>

                                <Link
                                  to="#!"
                                  className="mean-expand"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleMenu("nets");
                                  }}
                                >
                                  <i
                                    className={
                                      openMenus.nets
                                        ? "fa-solid fa-xmark"
                                        : "fa-regular fa-plus"
                                    }
                                  ></i>
                                </Link>

                                <ul
                                  className="submenu"
                                  style={{
                                    display: openMenus.nets ? "block" : "none",
                                  }}
                                >
                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/fishing-net"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      Fishing Net
                                    </NavLink>
                                  </li>

                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/agri_net"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      Agriculture Net
                                    </NavLink>
                                  </li>
                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/garden_net"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      Garden Net
                                    </NavLink>
                                  </li>
                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/build_net"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      Building Safety Net
                                    </NavLink>
                                  </li>
                                </ul>
                              </li>
                              <li
                                // className={`has-arrow ${
                                //   openMenus.roops ? "dropdown-opened" : ""
                                // }`}
                                className={`has-arrow ${
                                  openMenus.roops || ropeActive
                                    ? "dropdown-opened"
                                    : ""
                                } ${ropeActive ? "active" : ""}`}
                              >
                                <Link
                                  to="#"
                                  className={ropeActive ? "active" : ""}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  Roop's
                                </Link>

                                <Link
                                  to="#"
                                  className="mean-expand"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleMenu("roops");
                                  }}
                                >
                                  <i
                                    className={
                                      openMenus.roops
                                        ? "fa-solid fa-xmark"
                                        : "fa-regular fa-plus"
                                    }
                                  ></i>
                                </Link>

                                <ul
                                  className="submenu"
                                  style={{
                                    display: openMenus.roops ? "block" : "none",
                                  }}
                                >
                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/pp_rope"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      PP Danline Rope
                                    </NavLink>
                                  </li>

                                  <li onClick={closeMenu}>
                                    <NavLink
                                      to="/hdpe_rope"
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      HDPE Twine & Rope
                                    </NavLink>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/products"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              All Products
                            </NavLink>
                          </li>
                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/awards"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Awards
                            </NavLink>
                          </li>
                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/certification"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Certification
                            </NavLink>
                          </li>

                          <li
                            className={`menu-item-has-children ${
                              openMenus.media || mediaActive
                                ? "dropdown-opened"
                                : ""
                            }`}
                          >
                            <Link
                              to="#"
                              className={mediaActive ? "active" : ""}
                            >
                              Media
                            </Link>

                            <Link
                              to="#"
                              className="mean-expand"
                              onClick={() => toggleMenu("media")}
                            >
                              <i
                                className={
                                  openMenus.media
                                    ? "fa-solid fa-xmark"
                                    : "fa-regular fa-plus"
                                }
                              ></i>
                            </Link>

                            <ul
                              className="submenu last-children"
                              style={{
                                display: openMenus.media ? "block" : "none",
                              }}
                            >
                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/news"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  News & Events
                                </NavLink>
                              </li>

                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/gallery"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  Image Gallery
                                </NavLink>
                              </li>

                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/video"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  Video
                                </NavLink>
                              </li>
                            </ul>
                          </li>
                          <li
                            className={`menu-item-has-children ${
                              openMenus.act || policyActive
                                ? "dropdown-opened"
                                : ""
                            }`}
                          >
                            <Link
                              to="#"
                              className={policyActive ? "active" : ""}
                            >
                              Act & Policies
                            </Link>

                            <Link
                              to="#"
                              className="mean-expand"
                              onClick={() => toggleMenu("act")}
                            >
                              <i
                                className={
                                  openMenus.act
                                    ? "fa-solid fa-xmark"
                                    : "fa-regular fa-plus"
                                }
                              ></i>
                            </Link>

                            <ul
                              className="submenu last-children"
                              style={{
                                display: openMenus.act ? "block" : "none",
                              }}
                            >
                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/bepza_act"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  BEPZA Act
                                </NavLink>
                              </li>

                              <li onClick={closeMenu}>
                                <NavLink
                                  to="/labor_law"
                                  className={({ isActive }) =>
                                    isActive ? "active" : ""
                                  }
                                >
                                  EPZ Labor Law
                                </NavLink>
                              </li>
                            </ul>
                          </li>

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/contact"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Contact
                            </NavLink>
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <div className="rs-offcanvas-menu mb-25">
                      <nav></nav>
                    </div>
                  </div>
                </div>
              </div>

              <div className="offcanvas-contact mb-30">
                <h4 className="offcanvas-title-meta">Contact Info</h4>
                <ul>
                  <li className="d-flex align-items-center gap-15">
                    <div className="offcanvas-contact-icon">
                      <IoLocation size={18} color="#FF5C00" />
                    </div>

                    <div className="offcanvas-contact-text">
                      <Link to="#">
                        Natun Babu Para, Aminul Haq Road, <br />
                        Saidpur, Saidpur-5310, Nilphamari
                      </Link>
                    </div>
                  </li>
                  <li className="d-flex align-items-center gap-15">
                    <div className="offcanvas-contact-icon">
                      <FiPhoneCall size={16} color="#FF5C00" />
                    </div>
                    <div className="offcanvas-contact-text">
                      <Link to="tel:01833688844"> 01833688844 </Link>
                    </div>
                  </li>
                  <li className="d-flex align-items-center gap-15">
                    <div className="offcanvas-contact-icon">
                      <SiGmail size={16} color="#EA4335" />
                    </div>

                    <div className="offcanvas-contact-text">
                      <Link to="mailto:infoequegroup@gmail.com">
                        infoequegroup@gmail.com
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="offcanvas-social">
                <h4 className="offcanvas-title-meta">Subscribe & Follow</h4>
                <ul>
                  <li>
                    <Link to="#">
                      <i className="fab fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-x-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-youtube"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-linkedin"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`offcanvas-overlay ${menuOpen ? "overlay-open" : ""}`}
      ></div>
      <div className="offcanvas-overlay-white"></div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  /* 🔥 Active menu color */
  .main-menu Link.active {
    color: #ff5c00 !important;
  }

  /* Optional hover effect */
  .main-menu Link:hover {
    color: #ff5c00;
  }

  .mean-expand {
    cursor: pointer;
    font-size: 18px;
    margin-left: auto;
  }

  .submenu {
    list-style: none;
    padding-left: 20px;
  }
`;

export default Offcanvas;
